import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getFetchProductContentOptions from '@nike/shop-apis/product-feed-threads/v2/get-options';

/**
 * @memberof NikeShop
 * @name NikeShop.fetchProductDetails
 * @description Fetches product details for a given product ID
 *
 * @param {Object} params - The parameters for fetching product details
 * @param {string} params.productId - The product ID to fetch details for
 * @param {boolean} [params.fetchVasContent=true] - Whether to fetch VAS content
 * @returns {Promise<Object>} The product details data
 */
export default function fetchProductDetails(_x) {
  return _fetchProductDetails.apply(this, arguments);
}
function _fetchProductDetails() {
  _fetchProductDetails = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var productId, _ref$fetchVasContent, fetchVasContent, queryClient, transformedProductData;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          productId = _ref.productId, _ref$fetchVasContent = _ref.fetchVasContent, fetchVasContent = _ref$fetchVasContent === void 0 ? true : _ref$fetchVasContent;
          queryClient = window.NikeShop.__INTERNAL_USE__.queryClient;
          _context.next = 1;
          return queryClient.fetchQuery(getFetchProductContentOptions({
            queryClient: queryClient,
            productId: productId,
            fetchVasContent: fetchVasContent
          }));
        case 1:
          transformedProductData = _context.sent;
          return _context.abrupt("return", {
            data: {
              product: transformedProductData
            }
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchProductDetails.apply(this, arguments);
}